import { TFunction } from "i18next";
import { Control } from "react-hook-form";

import { ControlledSelect } from "@/components/shared/ControlledSelect";

import { StyledInputContainer, StyledSection } from "../styles";
import { GetCreationTemplateFormType } from "../types";

type DivisionSelectorProps = {
  control: Control<GetCreationTemplateFormType>;
  divisionOptions: { value: string; label: string }[];
  tFormData: TFunction<"formData">;
  onSelectWallet: () => void;
};

export const DivisionSelector = ({
  control,
  divisionOptions,
  tFormData,
  onSelectWallet,
}: DivisionSelectorProps) => (
  <StyledSection>
    <StyledInputContainer>
      <ControlledSelect
        control={control}
        name='walletId'
        namespace='formData'
        selectProps={{
          type: "options",
          options: divisionOptions,
          label: tFormData("formData.creationTemplate.divisionSelector"),
          dataTestId: "formdata__create-template-form_walletId-select",
          className: "select-division",
          onChange: () => {
            onSelectWallet();
          },
        }}
      />
    </StyledInputContainer>
  </StyledSection>
);
